"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHeaderHeight(gridApi) {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = gridApi) === null || _a === void 0 ? void 0 : _a.headerRootComp) === null || _b === void 0 ? void 0 : _b.eHeaderContainer) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 0;
}
function getCellElement(gridApi, attributeId, rowIndex) {
    var _a, _b, _c, _d;
    var rowRenderer = gridApi.rowRenderer;
    var rowCon = rowRenderer.rowConsByRowIndex[rowIndex];
    return (_d = (_c = (_b = (_a = rowCon === null || rowCon === void 0 ? void 0 : rowCon.centerRowComp) === null || _a === void 0 ? void 0 : _a.cellComps) === null || _b === void 0 ? void 0 : _b[attributeId]) === null || _c === void 0 ? void 0 : _c.eGui) !== null && _d !== void 0 ? _d : null;
}
function addCellClass(gridApi, attributeId, rowIndex, className) {
    var cellElement = getCellElement(gridApi, attributeId, rowIndex);
    if (cellElement !== null) {
        cellElement.classList.add(className);
    }
}
function removeCellClass(gridApi, attributeId, rowIndex, className) {
    var cellElement = getCellElement(gridApi, attributeId, rowIndex);
    if (cellElement !== null) {
        cellElement.classList.remove(className);
    }
}
function getPaginationBottomRowIndex(gridApi) {
    var _a, _b;
    var paginationProxy = gridApi.paginationProxy;
    if (paginationProxy) {
        return (_b = (_a = paginationProxy.bottomRowBounds) === null || _a === void 0 ? void 0 : _a.rowIndex) !== null && _b !== void 0 ? _b : null;
    }
    return null;
}
function getPinnedTopRowElement(gridApi) {
    var _a, _b, _c;
    var pinnedTopRow = gridApi.getPinnedTopRow(0);
    if (!pinnedTopRow) {
        return null;
    }
    var rootElement = (_a = gridApi.gridBodyComp) === null || _a === void 0 ? void 0 : _a.eGui;
    var rowElement = rootElement === null || rootElement === void 0 ? void 0 : rootElement.querySelector("[row-id=" + pinnedTopRow.id + "]");
    return (_c = (_b = rowElement === null || rowElement === void 0 ? void 0 : rowElement.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) !== null && _c !== void 0 ? _c : null;
}
function addPinnedTopRowClass(gridApi, className) {
    var rowElement = getPinnedTopRowElement(gridApi);
    if (rowElement) {
        rowElement.classList.add(className);
    }
}
function removePinnedTopRowClass(gridApi, className) {
    var rowElement = getPinnedTopRowElement(gridApi);
    if (rowElement) {
        rowElement.classList.remove(className);
    }
}
function setPinnedTopRowStyle(gridApi, propertyName, propertyValue) {
    var rowElement = getPinnedTopRowElement(gridApi);
    if (rowElement) {
        rowElement.style[propertyName] = propertyValue;
    }
}
exports.default = {
    getHeaderHeight: getHeaderHeight,
    // cell element
    getCellElement: getCellElement,
    addCellClass: addCellClass,
    removeCellClass: removeCellClass,
    // pinned row element
    getPinnedTopRowElement: getPinnedTopRowElement,
    addPinnedTopRowClass: addPinnedTopRowClass,
    removePinnedTopRowClass: removePinnedTopRowClass,
    setPinnedTopRowStyle: setPinnedTopRowStyle,
    // pinned row cell element
    getPaginationBottomRowIndex: getPaginationBottomRowIndex,
};
//# sourceMappingURL=agApiWrapper.js.map